<script>
import options from './StafetOpretHoldStepTwo.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-opret-hold-step-two kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourInformationTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          fieldName="firstName"
          :modelValue="firstName"
          v-model="firstName"
          :label="labels.yourInformationFirstNameLabel"
          :isRequired="true"
          :readOnly="readOnly.firstName"
          :isValidationError="showFirstNameErrorMessage"
          :errorMessageLabel="labels.yourInformationFirstNameErrorMessage"
          :onChangeCallback="(e) => validateField('firstName', e.target.value)"
        />

        <FormInputTextField
          fieldName="lastName"
          :modelValue="lastName"
          v-model="lastName"
          :label="labels.yourInformationLastNameLabel"
          :isRequired="true"
          :readOnly="readOnly.lastName"
          :isValidationError="showLastNameErrorMessage"
          :errorMessageLabel="labels.yourInformationLastNameErrorMessage"
          :onChangeCallback="(e) => validateField('lastName', e.target.value)"
        />
      </div>

      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          fieldName="email"
          :modelValue="email"
          v-model="email"
          :label="labels.yourInformationEmailLabel"
          :isRequired="true"
          :readOnly="readOnly.email"
          :isValidationError="showEmailErrorMessage"
          :errorMessageLabel="labels.yourInformationEmailErrorMessage"
          :onChangeCallback="(e) => validateField('email', e.target.value)"
        />
        
        <FormInputTextField
          fieldName="phone"
          :modelValue="phone"
          v-model="phone"
          :label="labels.yourInformationPhoneNumberLabel"
          :readOnly="readOnly.phone"
          :isValidationError="showPhoneErrorMessage"
          :errorMessageLabel="labels.yourInformationPhoneNumberErrorMessage"
          :onChangeCallback="(e) => validateField('phone', e.target.value)"
        />
      </div>
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="consent"
        :modelValue="consent.toString()"
        v-model="consent"
        :label="labels.yourInformationConsentBoolLabel"
        :isRichText="true"
        :isRequired="true"
        :readOnly="readOnly.consent"
        :isValidationError="showConsentErrorMessage"
        :errorMessageLabel="labels.yourInformationConsentBoolErrorMessage"
        :onChangeCallback="(e) => validateField('consent', e.target.checked)"
      />

      <FormCheckbox
        fieldName="newsletter"
        :modelValue="newsletter.toString()"
        v-model="newsletter"
        :readOnly="readOnly.newsletter"
        :label="labels.yourInformationNewsLetterBoolLabel"
        :onChangeCallback="(e) => validateField('newsletter', e.target.checked)"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationLastStep"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
